import CategorySelect from './CategorySelect'

export default CategorySelect
